import { defineComponent as _defineComponent } from 'vue'
import { TUIStore, StoreName } from "@tencentcloud/chat-uikit-engine";
import { ref } from "../../adapter-vue";
import ConversationList from "./conversation-list/index.vue";
import ConversationHeader from "./conversation-header/index.vue";
import ConversationNetwork from "./conversation-network/index.vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'index',
  emits: ["handleSwitchConversation"],
  setup(__props, { emit: emits }) {



const totalUnreadCount = ref(0);
const headerRef = ref<typeof ConversationHeader>();
const isShowConversationHeader = ref<boolean>(true);

TUIStore.watch(StoreName.CONV, {
  totalUnreadCount: (count: number) => {
    totalUnreadCount.value = count;
  },
});

TUIStore.watch(StoreName.CUSTOM, {
  isShowConversationHeader: (showStatus: boolean) => {
    isShowConversationHeader.value = showStatus !== false;
  },
});

const handleSwitchConversation = (conversationID: string) => {
  emits("handleSwitchConversation", conversationID);
};

const handleClickConv = () => {
  headerRef?.value?.closeChildren();
};

return { __sfc: true,emits, totalUnreadCount, headerRef, isShowConversationHeader, handleSwitchConversation, handleClickConv, ConversationList, ConversationNetwork }
}

})